const actions = {
  CREATE_THIRD_PARTY_ORDER: 'CREATE_THIRD_PARTY_ORDER',
  CREATE_PAYMENT_INIT: 'CREATE_PAYMENT_INIT',
  GET_THIRD_PARTY_ORDER: 'GET_THIRD_PARTY_ORDER',
  GET_THIRD_PARTY_ORDER_TRANSACTIONS: 'GET_THIRD_PARTY_ORDER_TRANSACTIONS',
  REFUND_THIRD_PARTY_ORDER: 'REFUND_THIRD_PARTY_ORDER',

  CREATE_THIRD_PARTY_ORDER_ENDED: 'CREATE_THIRD_PARTY_ORDER_ENDED',
  CREATE_PAYMENT_INIT_ENDED: 'CREATE_PAYMENT_INIT_ENDED',
  GET_THIRD_PARTY_ORDER_ENDED: 'GET_THIRD_PARTY_ORDER_ENDED',
  GET_THIRD_PARTY_ORDER_TRANSACTIONS_ENDED: 'GET_THIRD_PARTY_ORDER_TRANSACTIONS_ENDED',
  REFUND_THIRD_PARTY_ORDER_ENDED: 'REFUND_THIRD_PARTY_ORDER_ENDED',
};

export default actions;
